<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Salary Allowances",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport,
  },
  data() {
    return {
      title: "Salary Allowances",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Salary Allowances",
          active: true,
        },
      ],
      totalRows: 1,
      clientCurrentPage: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 10,
      IsAllowancesServerPaginated: true,
      filter: {
        datefrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateto: moment().format("YYYY-MM-DD"),
        staff: null,
        page: 1,
        per_page: 10,
      },
      tableSearch: "",
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingPayroll: [],
      staffError: "",
      amountError: "",
      modeError: "",
      dateError: "",
      monthError: "",

      // Value from user input for adding unit
      data: {
        staff: "",
        month_year: "",
        amount_paid: "",
        mode: "",
        date: "",
      },
      // edit unit
      editdata: {
        amount_paid: "",
        staff: "",
        id: "",
      },
      // delete unit
      deletedata: {
        staff: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("staff", [
      "StaffSave",
      "Staff",
      "StaffPayroll",
      "StaffAllowances",
      "StaffAllowancesPagination",
      "filterStatus",
    ]),
    ...mapGetters("auth", ["MyUserPerm", "branchid"]),
    ...mapGetters("setting", ["PaymentOptions"]),

    staffAllowancesPagination() {
      return (
        this.StaffAllowancesPagination || {
          from: 0,
          total: 0,
          current_page: 1,
          per_page: this.filter.per_page,
        }
      );
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.IsAllowancesServerPaginated
        ? this.staffAllowancesPagination.total
        : this.StaffAllowances
        ? this.StaffAllowances.length
        : 0;
    },

    currentPage: {
      get() {
        return this.IsAllowancesServerPaginated
          ? this.staffAllowancesPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsAllowancesServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsAllowancesServerPaginated
          ? this.filter.per_page || this.staffAllowancesPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsAllowancesServerPaginated) {
          this.serverPerPage = value;
          this.filter.per_page = value;
          this.filter.page = 1;
          this.fetchAllowancesStatement();
        } else {
          this.clientPerPage = value;
        }
      },
    },

    /**
     * Todo list of records
     */
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          this.resetAdd();
          this.resetEdit();
          // Re-apply active filters because store actions refresh advances without payload.
          this.fetchAllowancesStatement();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaff: "staff/fetchAllStaff",
      FetchStaffPayroll: "staff/fetchStaffPayroll",
      AddStaffAllowances: "staff/addStaffAllowance",
      FetchStaffAllowances: "staff/fetchStaffAllowances",
      EditStaffAllowances: "staff/editStaffAllowance",
      DeleteStaffAllowances: "staff/deleteStaffAllowance",
      FetchModes: "setting/fetchPaymentOptions",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsAllowancesServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    addStaffAllowances(modalId) {
      this.modal_id = modalId;

      if (this.data.staff === "") {
        this.staffError = "Staff field is required";
      } else if (this.data.amount_paid === "") {
        this.amountError = "Amount Paid field is required";
        return;
      } else if (this.data.mode === "") {
        this.modeError = "Payment mode field is required";
        return;
      } else if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else if (this.data.month_year === "") {
        this.dateError = "Month field is required";
        return;
      }

      this.AddStaffAllowances(this.data);
    },

    resetAdd() {
      this.data.staff = "";
      this.data.amount_paid = "";
      this.data.date = "";
      this.data.mode = "";
      this.data.month_year = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.editdata.amount_paid = "";
      this.editdata.staff = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.staff = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.staffError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.mobthError = "";
    },

    showEditModal(val) {
      this.editdata.staff = val.item.staff;
      this.editdata.amount_paid = val.item.amount_paid;
      this.editdata.id = val.item.id;
    },

    editStaffAllowances(modalId) {
      this.modal_id = modalId;

      if (this.editdata.amount_paid === "") {
        this.amountError = "Amount Paid field is required";
        return;
      }

      this.EditStaffAllowances(this.editdata);
    },

    showDeleteModal(val) {
      this.deletedata.staff = val.item.staff;
      this.deletedata.id = val.item.id;
    },

    deleteStaffAllowances(modalId) {
      this.modal_id = modalId;
      this.DeleteStaffAllowances(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount_paid = this.thousandSeprator(this.data.amount_paid);
      this.editdata.amount_paid = this.thousandSeprator(
        this.editdata.amount_paid,
      );
    },

    buildFilterPayload(newPage = 1) {
      this.filter.page = newPage;
      this.filter.per_page = this.serverPerPage;

      let payload = {
        page: this.filter.page,
        per_page: this.filter.per_page,
      };

      if (this.filter.datefrom) {
        payload.datefrom = this.filter.datefrom;
      }

      if (this.filter.dateto) {
        payload.dateto = this.filter.dateto;
      }

      if (this.filter.staff !== "" && this.filter.staff !== null) {
        payload.staff = this.filter.staff;
        payload.staff_id = this.filter.staff;
      }

      return payload;
    },

    fetchAllowancesStatement() {
      let payload = this.buildFilterPayload(this.filter.page || 1);
      this.FetchStaffAllowances(payload);
    },

    filterReport() {
      this.filter.page = 1;
      this.fetchAllowancesStatement();
    },

    handlePageChange(newPage) {
      if (this.IsAllowancesServerPaginated) {
        this.filter.page = newPage;
        this.fetchAllowancesStatement();
      }
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting staff allowances. Please try again.",
        confirmButtonText: "OK",
      });
    },
  },
  created() {
    this.FetchStaff();
    this.FetchStaffPayroll();
    this.fetchAllowancesStatement();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <h4 class="card-title">Staff Allowances</h4>
              </div>
              <div
                v-if="MyUserPerm.add_staff_salaries == 1 && branchid != 0"
                class="col-12 col-md-6 text-md-end text-start"
              >
                <b-button v-b-modal.add_staffallowance-modal variant="primary"
                  >Record Allowance</b-button
                >
              </div>
            </div>

            <div class="row mb-3 mt-1 align-items-end">
              <div class="col-12 col-md-auto">
                <div class="form-group mb-3">
                  <label class="d-block invisible mb-1">Export</label>
                  <ExcelExport
                    endpoint="staff_allowances/export"
                    filename="staff_allowances_report.xlsx"
                    :payload="filter"
                    button-text="Export Excel"
                    button-variant="info"
                    icon-class="fas fa-download"
                    @export-error="handleExportError"
                  />
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group mb-3">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filter.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="form-group mb-3">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filter.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="form-group mb-3">
                  <label>Filter by Staff</label>
                  <model-list-select
                    :list="[
                      { staff_id: '', staff: 'All Staff' },
                      ...(StaffPayroll || []),
                    ]"
                    v-model="filter.staff"
                    option-value="staff_id"
                    option-text="staff"
                    placeholder="Select Staff"
                    @input="filterReport()"
                  />
                </div>
              </div>

              <div class="col-12 col-md-auto">
                <div class="form-group mb-3 d-flex align-items-end h-100">
                  <button class="btn btn-primary" @click="filterReport">
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="tableSearch"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <table
                class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
              >
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>STAFF</th>
                    <th>MONTH-YEAR</th>
                    <th>AMOUNT</th>
                    <th>DISBURSED ON</th>
                    <th>PAYMENT MODE</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in StaffAllowances" :key="index">
                    <td>{{ staffAllowancesPagination.from + index+ 1 }}</td>
                    <td>{{ item.staff }}</td>
                    <td>{{ item.month_year }}</td>
                    <td>{{ thousandSeprator(item.amount_paid) }}</td>
                    <td>{{ item.date }}</td>
                    <td>
                      {{ item.mode.name }} ({{ item.mode.type_name }}-{{
                        item.mode.account_number
                      }})
                    </td>
                    <td>
                      <b-button-group>
                        <b-button
                          v-if="MyUserPerm.edit_staff_salaries == 1"
                          size="sm"
                          variant="primary"
                          v-b-modal.edit-allowance-modal
                          @click="showEditModal({ item })"
                          ><i class="fa fa-edit"></i
                        ></b-button>
                        <b-button
                          size="sm"
                          v-if="MyUserPerm.delete_staff_salaries == 1"
                          variant="danger"
                          v-b-modal.delete-allowance-modal
                          @click="showDeleteModal({ item })"
                          ><i class="fa fa-trash"></i
                        ></b-button>
                      </b-button-group>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="filterStatus">
                  <tr>
                    <td :colspan="12" class="text-center">
                      <div class="text-warning my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody
                  v-if="
                    !filterStatus &&
                    (!StaffAllowances || StaffAllowances.length === 0)
                  "
                >
                  <tr>
                    <td :colspan="12" class="text-center">
                      No allowance records found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal
      id="add_staffallowance-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-title> Add Allowance Payment</template>

      <div class="row">
        <div class="form-group mb-3">
          <label>Staff</label>
          <div class="input-group">
            <model-list-select
              :list="Staff ? Staff : []"
              v-model="data.staff"
              option-value="id"
              option-text="name"
              placeholder="Select staff"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="staffError">
            <em>{{ staffError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Amount Disbursed</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount Paid"
              class="form-control"
              v-model="data.amount_paid"
              @input="addCommas(), resetError()"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Month-Year</label>
          <div class="input-group">
            <input
              type="month"
              class="form-control"
              v-model="data.month_year"
              @input="resetError()"
            />
            <div class="text-danger" v-if="monthError">
              <em>{{ monthError }}</em>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Disbursed on</label>
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              v-model="data.date"
              @input="resetError()"
              v-limit-future-date
            />
            <div class="text-danger" v-if="dateError">
              <em>{{ dateError }}</em>
            </div>
          </div>
        </div>

        <div class="form-group mb-3">
          <label>Payment Method</label>
          <model-list-select
            :list="PaymentOptions ? PaymentOptions : []"
            v-model="data.mode"
            option-value="id"
            option-text="mode"
            placeholder="Select Method"
            @input="resetError()"
          >
          </model-list-select>
          <div class="text-danger" v-if="modeError">
            <em>{{ modeError }}</em>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add_staffallowance-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addStaffAllowances('add_staffallowance-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- edit modal starts -->
    <b-modal id="edit-allowance-modal" hide-footer>
      <template #modal-title> Edit Staff {{ editdata.staff }}</template>
      <div class="row">
        <div class="form-group mb-3">
          <label>Amount Disbursed</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount Paid"
              class="form-control"
              v-model="editdata.amount_paid"
              @input="addCommas(), resetError()"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-allowance-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editStaffAllowances('edit-allowance-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-allowance-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title>
        Delete Allowance payment for Staff {{ deletedata.staff }}</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-allowance-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteStaffAllowances('delete-allowance-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="StaffSave"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
.btn-xs {
  padding: 0.25rem 0.4rem;
  font-size: 0.875rem;
  line-height: 0.5;
  border-radius: 0.2rem;
}
</style>
